// Importa desde compat
import firebase from "firebase/compat/app";
import "firebase/compat/messaging";
import "firebase/compat/firestore";

// Importa helpers modernos de v9
import { isSupported, getToken } from "firebase/messaging";

const initializedFirebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyC1_0YPdfyAtzEPyqEqnnuXlTPYDz28vuY",
  authDomain: "nuestrosautos.firebaseapp.com",
  databaseURL: "https://nuestrosautos.firebaseio.com",
  projectId: "nuestrosautos",
  storageBucket: "nuestrosautos.appspot.com",
  messagingSenderId: "335738538887",
  appId: "1:335738538887:web:006151dd56fbf8153c2122",
});

const messaging = firebase.messaging();
const database = initializedFirebaseApp.firestore();

// 👉 Función para pedir token de FCM
export async function requestForToken() {
  const supported = await isSupported().catch(() => false);

  if (!supported) {
    console.warn("⚠️ FCM no soportado en este navegador.");
    return null;
  }

  try {
    const currentToken = await getToken(messaging, {
      vapidKey: "BCZd4IS34sDsacXssu24Pob9GcONVnW2ORYQt0GVKm92VXBOYKPDkn9Kf_14TpTYtuYgaw-6w8Vt5FLojjhhjOs", // 🔑 poné la clave pública de Firebase Cloud Messaging
    });

    if (currentToken) {
      console.log("✅ FCM Token:", currentToken);
      return currentToken;
    } else {
      console.warn("⚠️ No se obtuvo token (usuario bloqueó permisos o falta VAPID).");
      return null;
    }
  } catch (err) {
    console.error("❌ Error al obtener token:", err);
    return null;
  }
}

export { messaging, database };
